export const DELETE_BASE = 'INTEGRATION_CONFIG_DELETE';
export const DELETE_START = `${DELETE_BASE}_START`;
export const DELETE_SUCCESS = `${DELETE_BASE}_SUCCESS`;
export const DELETE_FAIL = `${DELETE_BASE}_FAIL`;

export function doDelete(planId) {
  return {
    type: DELETE_BASE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}`,
      method: 'del',
    },
  };
}
